import type { TabNavigationType } from '../../app/package/base/router/router-types/router-types';
import type { ComplianceActionTypes } from '../../app/package/base/service/activation-flow/activation-flow-domain';

export const ROUTER_EVENTS = {
  NAVIGATE_TO: 'router:navigateTo',
  NAVIGATE_TO_GAME: 'router:navigateToGame',
} as const;

export type RouterEventPayloads = {
  [ROUTER_EVENTS.NAVIGATE_TO]: {
    page: string;
    tabBehavior?: TabNavigationType;
    complianceAction?: ComplianceActionTypes;
  };
  [ROUTER_EVENTS.NAVIGATE_TO_GAME]: {
    playForReal: boolean;
    gameId: string;
  };
};
